const isBlank = (str: string) => !str || str.length === 0 || !/\S/.test(String(str));

export default isBlank;
